export default __webpack_public_path__ + "static/media/aba_taxi.43f093fe.png";